export var FooterElementType;
(function (FooterElementType) {
    FooterElementType["Category"] = "category";
    FooterElementType["Column"] = "column";
    FooterElementType["Item"] = "item";
})(FooterElementType || (FooterElementType = {}));
export var FooterItemType;
(function (FooterItemType) {
    FooterItemType["Button"] = "button";
    FooterItemType["Image"] = "image";
    FooterItemType["Link"] = "link";
    FooterItemType["Text"] = "text";
})(FooterItemType || (FooterItemType = {}));
export var FooterItemUrlType;
(function (FooterItemUrlType) {
    FooterItemUrlType["Email"] = "email";
    FooterItemUrlType["Link"] = "link";
    FooterItemUrlType["Phone"] = "phone";
    FooterItemUrlType["Whatsapp"] = "whatsapp";
})(FooterItemUrlType || (FooterItemUrlType = {}));
export var FooterCategoryWidth;
(function (FooterCategoryWidth) {
    FooterCategoryWidth["Regular"] = "regular";
    FooterCategoryWidth["Wide"] = "wide";
    FooterCategoryWidth["ExtraWide"] = "extra-wide";
})(FooterCategoryWidth || (FooterCategoryWidth = {}));
//# sourceMappingURL=footer.js.map